// @flow

import { type Node } from 'react';

import { type Feature, type FeatureName } from './types';
import { type Trait } from '../trait';

type Props = {|
  +allFeatures: ImmutableArray<Feature>,
  +wanted: FeatureName,
  +children: Node | (traits: ImmutableArray<Trait>) => Node,
|};

export function IfFeature({ allFeatures, wanted, children }: Props): Node {
  const feature = allFeatures.find(feature => feature.name === wanted);

  if (!feature) {
    return null;
  }

  return typeof children === 'function'
    ? children(feature.traits ? feature.traits : [])
    : children;
}
